import React from 'react';

import { SxProps } from '@mui/material';
import { TBlock } from '@wp-block-builder/package';

import getBlockIconComponent from './getBlockIconComponent';

type Props = {
  type: TBlock['type'];
  sx?: SxProps;
};

export default function BlockTypeIcon({ type, sx }: Props): JSX.Element {
  const Component = getBlockIconComponent(type);
  return <Component sx={sx} />;
}
